<template>
  <div class='form-elements'>
    <div class='row'>
      <div class='flex xs10 offset--xs1'>
        <va-card :title='title'>
          <div class='flex md8 offset--md2 sm6 xs8'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class='flex md8 offset--md2 sm6 xs8'>
            <va-input
              v-model='insertData.name'
              label='姓名'
              removable
              :messages="messages"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class='flex md8 offset--md2 sm6 xs8' v-show="insertData.avatar.length!==0">
            <va-card
              overlay
              :image='insertData.avatar'
              class="va-card-image"
            >
            </va-card>
          </div>
          <div class='flex md8 offset--md2 sm6 xs8'>
            <va-card title='上传导师头像'>
              <va-file-upload
                type='single'
                v-model='insertData.avatarArr'
                @input="uploadMentorAvatar"
              />
            </va-card>
          </div>
          <div class='flex md8 offset--md2 sm6 xs8'>
            <va-input
              v-model='insertData.position'
              label='职位'
              removable
              :messages="messages"
              :error="!!error.positionErrors.length"
              :error-messages="error.positionErrors"
            />
          </div>
          <div class='flex md8 offset--md2 sm6 xs8' v-show="insertData.enterpriseLogo.length!==0">
            <va-card
              overlay
              :image='insertData.enterpriseLogo'
              class="va-card-image"
            >
            </va-card>
          </div>
          <div class='flex md8 offset--md2 sm6 xs8'>
            <va-card title='上传学校/企业Logo'>
              <va-file-upload
                type='single'
                v-model='insertData.enterpriseLogoArr'
                @input="uploadEnterpriseLogo"
              />
            </va-card>
          </div>
          <div class='flex md8 offset--md2 sm6 xs8'>
            <va-input
              type='textarea'
              v-model='insertData.experience'
              label='经历(前端需要换行的话要用；分隔开)'
              removable
              :messages="messages"
              :error="!!error.experienceErrors.length"
              :error-messages="error.experienceErrors"
            />
          </div>
          <div class='flex md8 offset--md2 sm6 xs8'>
            <va-input
              type='textarea'
              v-model='insertData.strength'
              label='优势(前端需要换行的话要用；分隔开)'
              removable
              :messages="messages"
              :error="!!error.strengthErrors.length"
              :error-messages="error.strengthErrors"
            />
          </div>

          <div class='flex md8 offset--md2 sm6 xs8'>
            <va-input
              v-model='insertData.sortNum'
              label='排序'
              removable
              :messages="messages"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
              placeholder="数字越小靠前"
              type="number"
              :min="1"
            />
          </div>
          <div class='flex md2 offset--md5'>
            <va-button class="ma-0" color="primary" slot="trigger" @click="submit" :disabled="!submitButtonStatus">
              submit
            </va-button>
          </div>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>

import mentorApi from '../../../api/liuxue/mentor'
import uploadApi from '../../../api/upload'
import { copyObject } from '../../../utils/common'

export default {
  data () {
    return {
      insertData: {
        id: null,
        name: '',
        avatarArr: [],
        avatar: '',
        position: '',
        enterpriseLogoArr: [],
        enterpriseLogo: '',
        experience: '',
        sortNum: null,
        active: 1,
        strength: '',
      },
      error: {
        nameErrors: [],
        positionErrors: [],
        experienceErrors: [],
        sortNumErrors: [],
        strengthErrors: [],
      },
      messages: ['required field'],
      showId: false,
      title: '新增导师',
      submitButtonStatus: true,
    }
  },
  created () {
    const params = this.$route.params
    console.log(params)
    if (params.id != null) {
      this.showId = true
      this.title = '编辑导师'
      // 通过id获取详情
      mentorApi.getMentor(params.id).then(response => {
        copyObject(response, this.insertData)
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
  },
  computed: {
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.positionErrors.length &&
          !this.error.experienceErrors.length &&
          !this.error.sortNumErrors.length &&
          !this.error.strengthErrors.length
    },
  },
  methods: {
    uploadMentorAvatar () {
      if (this.insertData.avatarArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', this.insertData.avatarArr[0])
      // 保存avatar图片
      uploadApi.uploadImage(formData).then(response => {
        this.insertData.avatar = response.url
      })
    },
    uploadEnterpriseLogo () {
      if (this.insertData.enterpriseLogoArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', this.insertData.enterpriseLogoArr[0])
      // 保存avatar图片
      uploadApi.uploadImage(formData).then(response => {
        this.insertData.enterpriseLogo = response.url
      })
    },
    submit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      if (this.insertData.enterpriseLogo.length === 0 || this.insertData.avatar.length === 0) {
        this.showToast('有图片未上传，请请检查后重试！', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      this.changeButtonStatus(false)
      const data = {
        name: this.insertData.name,
        avatar: this.insertData.avatar,
        position: this.insertData.position,
        active: this.insertData.active,
        strength: this.insertData.strength,
        enterpriseLogo: this.insertData.enterpriseLogo,
        experience: this.insertData.experience,
        sortNum: this.insertData.sortNum,
      }
      if (this.insertData.id != null) {
        data.id = this.insertData.id
        mentorApi.updateMentor(this.insertData.id, data).then(response => {
          if (response.success === true) {
            this.$router.push({ name: 'listMentor' })
          } else {
            this.changeButtonStatus(true)
          }
        })
      } else {
        mentorApi.addMentor(data).then(response => {
          if (response.success === true) {
            this.$router.push({ name: 'listMentor' })
          } else {
            this.changeButtonStatus(true)
          }
        })
      }
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.positionErrors = this.insertData.position ? [] : ['position is required']
      this.error.experienceErrors = this.insertData.experience ? [] : ['experience is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
      this.error.strengthErrors = this.insertData.strength ? [] : ['strength is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}
</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
